export class ResponseBase {
    success: boolean = false;
    message?: string;
    errorCode?: number;
    header?: string;
}